

import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
//                  local
import { UserProfile } from 'src/shared/models/user-profile.model';
import { ProfileService } from 'src/shared/services/profile.service';
import { Deferred } from 'src/app/utilities';
import { Sandbox } from 'src/app';
import { ServiceUtil } from 'src/shared/utilities/service.util';

@Injectable()
class UserService {
  private dAuthenticated = new Deferred();
  private dUserData = new Deferred();
  private dProfile = new Deferred();
  private dUser = new Deferred();
  public data: UserProfile = new UserProfile();
  private _controllerName: string = 'connect'; 

  private compileUser(data, profile) {
    let { sub, given_name, family_name, email, role, corporationId } = data && data.userData ? data.userData : { sub: null, given_name: null, family_name: null, email: null, role: null, corporationId: null };
    let { userApplications, loginMethod, brandingImage, brandingName, sessionTimeoutMinutes, isRootAdmin, isNonSSOUser, isTwoFactorEnabled } = profile;
    let roles = Array.prototype.concat.call([], role);
    let user = new UserProfile({ userId: sub, firstName: given_name, lastName: family_name, email, userApplications, loginMethod, brandingImage, brandingName, roles, corporationId, sessionTimeoutMinutes, isRootAdmin, isNonSSOUser, isTwoFactorEnabled });

    return user;
  }

  private async observeAuthenticated(authenticated: boolean) {
    if (!authenticated) return;
    this.dAuthenticated.resolve(authenticated);
  }

  private async observeUserData(data: any) {
    if (!data || !data.userData) return;
    this.dUserData.resolve(data);
  }

  constructor(
    private _serviceUtil: ServiceUtil,
    private $: Sandbox,
    private _oidcSecurityService: OidcSecurityService,
    private _profileService: ProfileService) {
    
    let dAuthenticated = this.dAuthenticated
      , dUserData = this.dUserData
      , dProfile = this.dProfile
      , dUser = this.dUser;
    let pAuthenticated = dAuthenticated.promise
      , pUserData = dUserData.promise
      , pProfile = dProfile.promise
      , pUser = dUser.promise;
    //these are used to control the order of execution
    //1- dAuthenticated 2- dUserData 3- dProfile 4 - dUser 5 - handleUserReady
    let promises = Promise.all([pAuthenticated, pUserData, pProfile]);
    let profilePromise = pUserData.then((data) => this._profileService.getUserProfileData());  // when user-data, then get profile data

    profilePromise.then(this.handleProfile.bind(this));  // resolve profile data for pProfile
    promises.then(this.handleAll.bind(this));
    pUser.then(this.handleUserReady.bind(this));

    this._oidcSecurityService.isAuthenticated$.subscribe((result) => {
      if (result.isAuthenticated) {
        this.observeAuthenticated(result.isAuthenticated);
      }

    });
    this._oidcSecurityService.userData$.subscribe(data => {
      this.observeUserData(data);
    });
  }

  protected handleMobileAppAuthenticated(isAuthenticated: boolean) {
    if (!isAuthenticated) { return; }

    this.dAuthenticated.resolve((isAuthenticated === true));
    this.getUserDataFromUserInfoEndpoint().then((data) => {
      if (data != null) {
        this.dUserData.resolve(data);
      }
    });
  }

  getUserDataFromUserInfoEndpoint(): Promise<any> {
    return this._serviceUtil.doGetRequestAsync(this._controllerName, 'userinfo');
  }

  handleProfile(profile: any) {
    if (!profile) return;
    this.dProfile.resolve(profile);
    return profile;
  }

  handleAll(resolutions: any[]) {
    let [authenticated, data, profile] = resolutions;
    if (!authenticated) return null;
    let user = this.compileUser(data, profile);

    this.dUser.resolve(user);

    return resolutions;
  }

  handleUserReady(user: UserProfile) {
    this.data = user;
    this.$.publish(this.$.channels['AUTHENTICATION:USER'], user);
  }

}

export { UserService };
